// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  key: __t.string().primaryKey(),
  instance: __t.u32(),
  placementId: __t.string().name("placement_id"),
  definition: __t.u16(),
  revision: __t.u32(),
  x: __t.i32(),
  y: __t.i32(),
  offsetX: __t.i32().name("offset_x"),
  offsetY: __t.i32().name("offset_y"),
  depleted: __t.bool(),
  regrowTick: __t.u32().name("regrow_tick"),
});
